<div class="modal-header">
  <h4 class="modal-title">{{'choiceActionCae.title' | translate}}
    <a class="link ps-2" href="javascript:void(0)" data-gatm="global.label.help" (click)="openHELPLink()" tooltip [tooltipText]="'global.label.help' | translate"><app-svg-icon type="information_circle" [inline]="true"/></a>
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <p class="mt-2">{{'openProjectComponent.label.cae_download' | translate}}
      <a class="green u-hover" href="{{'openProjectComponent.link.cae_download' | translate}}" target="_blank">{{'openProjectComponent.label.cae_download_link_part' | translate}}</a>.
    </p>
    <p>{{'global.label.choiceActionComponents' | translate}}</p>
    <div class="ps-5">
      <div class="form-check">
        <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="types[0]" [(ngModel)]="actionType">
        <label class="form-check-label" for="radio1" [innerHTML]="'<b>' + ('projectNavigation.cae_import_title' | translate) + '</b><br><span>' + ('choiceActionCae.label.import_project' | translate) + '</span>'"></label>
      </div>
      <div class="form-check mt-3">
        <input [disabled]="!currentProject?.id || currentProject?.projectGroup?.importType !== 'CAE_TYPE'" type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="types[1]" [(ngModel)]="actionType">
        <label data-testid="export-cae-radio-button" class="form-check-label" for="radio2" [innerHTML]="'<b>' + ('projectNavigation.cae_export_title' | translate) + '</b><br><span>' + ('choiceActionCae.label.export_project' | translate) + '</span>'"></label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" data-testid="close-button" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" data-testid="confirm-button" (click)="onConfirm()">{{'global.label.next' | translate}}</button>
</div>
